export const MUSIC_LANGUAGES = [
  { value: 'Arabic', label: 'العربية' },
  { value: 'Chinese', label: '中文' },
  { value: 'Dutch', label: 'Nederlands' },
  { value: 'English', label: 'English' },
  { value: 'French', label: 'Français' },
  { value: 'German', label: 'Deutsch' },
  { value: 'Hindi', label: 'हिन्दी' },
  { value: 'Italian', label: 'Italiano' },
  { value: 'Japanese', label: '日本語' },
  { value: 'Korean', label: '한국어' },
  { value: 'Kurdish', label: 'Kurdî' },
  { value: 'Persian', label: 'فارسی' },
  { value: 'Portuguese', label: 'Português' },
  { value: 'Russian', label: 'Русский' },
  { value: 'Spanish', label: 'Español' },
  { value: 'Turkish', label: 'Türkçe' },
  { value: 'Ukrainian', label: 'Українська' },
  { value: 'Other', label: 'Other / Diğer' }
].sort((a, b) => a.label.localeCompare(b.label));

export const DEFAULT_LANGUAGE = 'Turkish'; 